// src/components/Oauth/Oauth.jsx
import React from 'react';
import { GOOGLE_CLIENT_ID, GOOGLE_REDIRECT_URI } from '../../config';

const Oauth = ({name, icon}) => {
  const handleGoogleLogin = () => {
    const baseUrl = 'https://accounts.google.com/o/oauth2/v2/auth';
    const scope = 'openid email profile';
    // Сохраняем redirect path в state параметре OAuth для надёжности
    const redirectPath = sessionStorage.getItem('authRedirectPath') || '';
    const params = new URLSearchParams({
      client_id: GOOGLE_CLIENT_ID,
      redirect_uri: GOOGLE_REDIRECT_URI,
      response_type: 'code',
      scope: scope,
      access_type: 'offline',
      prompt: 'select_account',
      state: redirectPath,
    });

    window.location.href = `${baseUrl}?${params.toString()}`;
  };

  return (
    <div>
      <button className='auth-button' onClick={handleGoogleLogin}>
        {icon} {name}
      </button>
    </div>
  );
}

export default Oauth;